import React from 'react'
import MuiFormHelperText, { FormHelperTextProps } from '@material-ui/core/FormHelperText'

export const FormHelperText = (props: FormHelperTextProps) => <MuiFormHelperText {...props} />
